import { API_TYPE, IApi, IResponse, fetchData } from '@umu/umu-fetch';
import { IUserBaseInfo } from '@umu/umu-types';

const API: {
    [key: string]: IApi;
} = {
    /** 获取企业证书 */
    GET_STUDENT_CERTIFICATE_INFO: {
        url: '/uapi/v1/enterprise-certificate/get-student-certificate-info',
        type: API_TYPE.GET,
    },
    MIGRATE_HTML_TO_PIC: {
        url: '/napi/resource/migrate/html-to-pic',
        type: API_TYPE.GET,
    },
    HTML_TO_PIC_STATUS: {
        url: '/napi/resource/html-to-pic-status',
        type: API_TYPE.GET,
    },
    ENT_COURSE_OBTAINED_USER_LIST: {
        url: '/uapi/v1/enterprise-certificate/course-obtained-user-list',
        type: API_TYPE.GET,
    },
};

export default API;

interface IStudentCertificateInfoParams {
    course_id: string;
}

interface ICertificateBaseInfo {
    id: string;
    name: string;
    is_repetitive_mode: number;
    valid_period: number;
    status: number; // 0为未开启，1为已启用，2为已停用
}
type ICertificateSetUp = Record<string, number>;

interface ICertificateInfo extends ICertificateBaseInfo {
    certificate_id: string;
    name: string;
    valid_period: number;
    teacher_name?: string;
    course_id: string;
    is_close_course_certificate: number;
    is_repetitive_mode: number;
    title: string;
    text: string;
    issue_enterprise: string;
    logo: string;
    theme_background: string;
    theme_img: string;
    setup: ICertificateSetUp;
    depend_learning_task: number;
    is_top: number;
}
interface IRelateCourseInfo {
    id: string;
    title: string;
    copy_num: number;
    access_code: string;
    session_num?: number;
    latest_course_id?: string;
    show_pic?: string;
    mode?: number;
    share_url: string;
}
interface ICertificateStat {
    no_acquired_num: number;
    expired_num: number;
    effective_num: number;
    assign_student_num?: number;
    course_participate_num?: number;
}
/*
获取证书模式 1-任务进行中 2-正常获取 3-逾期获取 4.任务失效 5-任务被撤回 6-任务逾期未完成
*/
enum GET_CERTIFICATE_MODE {
    TASK_IN_PROGRESS = '1',
    NORMAL_ACQUISITION = '2',
    OVERDUE_ACQUISITION = '3',
    MISSION_FAILURE = '4',
    TASK_WITHDRAWAL = '5',
    TASK_OVERDUE_NOT_COMPLETED = '6',
}
interface IStudentCertificateInfo {
    certificate_task_status: string;
    create_time: string;
    effective_ts: string;
    enterprise_id: string;
    expire_ts: string;
    get_certificate_mode: GET_CERTIFICATE_MODE;
    grant_ts: string;
    id: string;
    certificate_status: number;
    student_certificate_status: string;
    update_time: string;
}
export interface ICertificateItemInfo {
    certificate_base_info: ICertificateInfo;
    relate_course_info: IRelateCourseInfo;
    current_course_info?: IRelateCourseInfo;
    certificate_stat: ICertificateStat;
    student_certificate_info?: IStudentCertificateInfo;
    student_info?: {
        umu_id: string;
        user_name: string;
        number: string;
        uid: string;
    };
}

export const getStudentCertificateInfo = (
    params: IStudentCertificateInfoParams,
): Promise<IResponse<ICertificateItemInfo>> => {
    return fetchData(API.GET_STUDENT_CERTIFICATE_INFO, params, {
        silent: true,
    });
};

interface IMigrateHtmlToPicParams {
    obj_id: string;
    obj_type: string;
    student_id: string;
}
export const migrateHtmlToPic = (params: IMigrateHtmlToPicParams): Promise<IResponse<{ id: string }>> => {
    return fetchData(API.MIGRATE_HTML_TO_PIC, params);
};
interface IHtmlToPicStatusResponse {
    pic_url: string;
    status: number;
    source_url: string;
}
export const getHtmlToPicStatus = (params: { id: string }): Promise<IResponse<IHtmlToPicStatusResponse>> => {
    return fetchData(API.HTML_TO_PIC_STATUS, params);
};

interface IBasePageInfo {
    current_page: number;
    list_total_num: number;
    size: number;
    total_page_num: number;
}

interface IBaseList<T> {
    list: T[];
    page_info: IBasePageInfo;
}
export const getEnterpriseCertObtainedUserList = (params: {
    course_id: string;
    page: number;
    size: number;
}): Promise<IResponse<IBaseList<IUserBaseInfo>>> => {
    return fetchData(API.ENT_COURSE_OBTAINED_USER_LIST, params);
};
